export const team23 = [
  {
    "year": "2022-2023",
    "CoreTeam": [
      {
        "Position": "Chairperson",
        "Name": "Shravani Garine",
  
        "ImgPath": "Shravani.jpg"
      },
      {
        "Position": "Vice Chairperson",
        "Name": "K V K Akhil",
        "ImgPath": "Akhil.jpg"
      },
      {
        "Position": "Secretary",
        "Name": "K. Sai Vamshi",
        "ImgPath": "Vamshi.jpg"
      },
      {
        "Position": "Treasurer",
        "Name": "G. Dhanush",
        "ImgPath": "Dhanush.JPG"
      },
      {
        "Position": "Membership Chair",
        "Name": "Gandla Sravani",
        "ImgPath": "Sravani.jpeg"
      },
      {
        "Position": "Webmaster",
        "Name": "Avighna Gandra",
        "ImgPath": "Avighna.jpeg"
      },
      {
        "Position": "Activities Cordinator",
        "Name": "Nithin",
        "ImgPath": "Nithin.jpeg"
      }
    ],
    "TeamHeads": [
      {
        "Position": "Social Media Head",
        "Name": "Akshitha Mashetty",
        "ImgPath": "Akshitha.jpeg"
      },
      {
        "Position": "Events & PR Head",
        "Name": "K Samhith Reddy",
        "ImgPath": "Samhith.jpeg"
      },
      {
        "Position": "Technical Head",
        "Name": "B Sri Varshitha",
        "ImgPath": "Varshitha.jpeg"
      },
      {
        "Position": "Design Team Head",
        "Name": "Sanjana Gunturu",
        "ImgPath": "Sanjana.jpeg"
      },
      {
        "Position": "Coding Team Head",
        "Name": "B Anirudh",
        "ImgPath": "Anirudh.jpeg"
      }
    ],
    "Test": [
      {
        "Name": "Avighna",
        "Desig": "Webmaster(2022-2023)",
        "Content": "ACM VNRVJIET is the best platform that any student could have, to experience life as a student to the fullest. The chapter is always devoted to finding the requirements of the students in order to bridge the gap between academics and overall growth of the student to help them become a better individual and excel as a team player and stand out from the competitive world around them. It successfully brought up many highly acclaimed programs with great zeal. I am a grateful member of this chapter which helped me to kick start, understand and explore many things that helped me grow both personally and professionally. Everything about this chapter fascinated me, inspired me to join as a volunteer and become a part of its vision and mission.",
        "imgPath": "Avighna.jpeg"
      },
      {
        "Name": "Shravani",
        "Desig": "Chairperson(2022-2023)",
        "Content": "My experience as a volunteer for ACM VNRVJIET is exceptional. This is one of my finest B.Tech life experiences. This chapter has taught me a lot of new things. From a less confident, striving introvert to someone who can confidently showcase their skills and manage a team with 20 different mindsets. By organising various events, I have honed my management and leadership abilities. I'm extremely grateful for the effective work culture and teamwork here, which contribute to the success of events. I'm very thankful to all of my seniors for assisting me in quickly sorting things out. I am a better individual owing to ACM.",
        "imgPath": "Shravani.jpg"
      },
      {
        "Name": "Akhil",
        "Desig": "Vice Chairperson(2022-2023)",
        "Content": "It is believed that a person’s life is molded in the early 20s and it is very important to be in the right place. In that case, I am glad that ACM VNRVJIET happened to me. ACM VNRVJIET has been a great contributor to the development of my personality. I have established my leadership, time management, and team skills and have also been able to advance these skills. From participating in events to conducting events through ACM VNRVJIET, my learnings and experiences will always be my fundamentals for any milestone I achieve.",
        "imgPath": "Akhil.jpg"
      },
      {
        "Name": "Dhanush",
        "Desig": "Treasurer(2022-2023)",
        "Content": "It is believed that a person’s life is molded in the early 20s and it is very important to be in the right place. In that case, I am glad that ACM VNRVJIET happened to me. ACM VNRVJIET has been a great contributor to the development of my personality. I have established my leadership, time management, and team skills and have also been able to advance these skills. From participating in events to conducting events through ACM VNRVJIET, my learnings and experiences will always be my fundamentals for any milestone I achieve.",
        "imgPath": "Dhanush.JPG"
      }
    ],
    "Volunteers": [
      {
        "Name": "Srinibha Srikanth",
        "Mail": "srinibha.srikanth@gmail.com",
        "Team": "Social Media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Aashritha Bibireddy",
        "Mail": "aashrithabibireddy@gmail.com",
        "Team": "Social media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "L. Varunesh",
        "Mail": "lvarunesh26@gmail.com",
        "Team": "Social media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "S. Rishikesh",
        "Mail": "rishikeshsara03@gmail.com",
        "Team": "Social media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "R. Sai Adithya",
        "Mail": "aditxyaa@gmail.com",
        "Team": "Social media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Neela Varun Gopal",
        "Mail": "varunvr2203@gmail.com",
        "Team": "Social media",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Kambhampati Sai Harsha Vardhan",
        "Mail": "harshaspartax18@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Kodaru Jayanth",
        "Mail": "jayanthroy555@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Suryateja Chittiprolu",
        "Mail": "suryatejach04@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Imadabathuni Suhrutha",
        "Mail": "suhrutha2004@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Shanmukhi",
        "Mail": "shanmukhikurapati2425@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Chandrakethan Sivarsthri",
        "Mail": "s.chandrakethan9@gmail.com",
        "Team": "Technical",
        "imgPath": "avatar.png"
      },
      {
        "Name": "N Sravya Reddy",
        "Mail": "Sravyareddy.n06@gmail.com",
        "Team": "Events and PR",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Billakanti Krishna sai",
        "Mail": "krishnasaibillakanti08@gmail.com",
        "Team": "Events and PR",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Sri Swapnika Dodla",
        "Mail": "sriswapnikad@gmail.com",
        "Team": "Events and PR",
        "imgPath": "avatar.png"
      },
      {
        "Name": "N. Siddharth Reddy",
        "Mail": "siddharthreddy210603@gmail.com",
        "Team": "Events and PR",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Sai Meghana Maradana",
        "Mail": "saimeghanait@gmail.com",
        "Team": "Events and PR",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Chilla Srivaibhav",
        "Mail": "srivaibhavchilla2923@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      },
      {
        "Name": "J. Vinish Reddy",
        "Mail": "vinishreddy1604@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Lalitha Bhavana M",
        "Mail": "lalithabhavana9@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Praneetha Madala",
        "Mail": "praneetha.Madala@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Komma Vishal",
        "Mail": "kommavishal@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      },
      {
        "Name": "Potluri Srinija",
        "Mail": "srinijapotluri@gmail.com",
        "Team": "Design",
        "imgPath": "avatar.png"
      }
    ]
  }
];
